<template>
<div>
    <zm-row>
        <zm-button @click="showCreate" type="primary" plain>Create Statement</zm-button>
    </zm-row>
    <div class="table-container">
        <zm-table v-loading="loading" :data="list.slice((pageable.pageNumber - 1) * pageable.pageSize, pageable.pageNumber * pageable.pageSize)">
            <zm-table-column prop="name" label="Name" width="250px" show-overflow-tooltip></zm-table-column>
            <zm-table-column prop="version" label="Version" width="250px" show-overflow-tooltip></zm-table-column>
            <zm-table-column prop="description" label="Description"></zm-table-column>
            <zm-table-column width="110px">
                <template slot-scope="scope">
                    <zm-button type="icon" icon="zm-icon-edit" @click="showEdit(scope.row)"></zm-button>
                    <zm-button type="icon" icon="zm-icon-delete" @click="showDelete(scope.row.id)"></zm-button>
                </template>
            </zm-table-column>
        </zm-table>
        <div style="text-align: center" class="pagination-wrap">
            <zm-pagination @size-change="handleSizeChange"
                :current-page.sync="pageable.pageNumber"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageable.pageSize"
                layout="sizes, total, prev, pager, next, jumper"
                :total="list.length">
            </zm-pagination>
        </div>
    </div>
    <zm-dialog :visible.sync="visible" :title="form.title">
        <zm-form label-width="130px">
            <zm-form-item prop="name">
                <div slot="label">
                    <tip label="Name" id="permission-statement-name"></tip>
                </div>
                <zm-input v-model="form.name" :disabled="form.title === 'Edit Statement'"></zm-input>
            </zm-form-item>
            <zm-form-item>
                <div slot="label">
                    <tip label="Description" id="permission-statement-description"></tip>
                </div>
                <zm-input v-model="form.description"></zm-input>
            </zm-form-item>
            <zm-form-item>
                <div slot="label">
                    <tip label="Version" id="permission-statement-version"></tip>
                </div>
                <zm-input-number v-model="form.version" :min="0"></zm-input-number>
            </zm-form-item>
            <zm-form-item>
                <div slot="label">
                    <tip label="Resource" id="permission-statement-resource"></tip>
                </div>
                <zm-tree
                    class="resource-tree"
                    show-checkbox
                    :data="actionList"
                    ref="tree"
                    node-key="id"
                    @check-change="handleCheckChange">
                </zm-tree>
            </zm-form-item>
        </zm-form>
        <div slot="footer">
            <zm-button @click="visible = false">Cancel</zm-button>
            <zm-button @click="save" type="primary" :loading="loading">Submit</zm-button>
        </div>
    </zm-dialog>
</div>
</template>
<script>
import {
    getAllStatementMenus,
    getAllStatements,
    createStatement,
    editStatementPolicy,
    deleteStatement
} from '@/api/statement'
import tip from '@/components/ToolTip/index'
export default {
    name: 'statement',
    components: { tip },
    data () {
        return {
            list: [],
            actionList: [],
            loading: false,
            visible: false,
            form: {
                title: '',
                id: '',
                name: '',
                description: '',
                policies: [
                    {
                        type: '',
                        value: '',
                        operation: '',
                        valueList: []
                    }
                ],
                version: 0
            },
            cachePolicy: [],
            pageable: {
                pageSize: 10,
                pageNumber: 1
            }
        }
    },
    created () {
        this.fetchData()
        this.fetchMenu()
    },
    methods: {
        showCreate () {
            this.form.title = 'Create Statement'
            this.form.id = ''
            this.form.name = ''
            this.form.description = ''
            this.form.policies = []
            this.cachePolicy = []
            this.visible = true
            this.actionList.map(action => {
                action.actions = []
            })
            this.$nextTick(() => {
                this.$refs.tree.setCheckedKeys([])
            })
        },
        showEdit (row) {
            this.visible = true
            this.form.title = 'Edit Statement'
            this.form.id = row.id
            this.form.name = row.name
            this.form.description = row.description
            this.form.policies = row.policies
            this.cachePolicy = []
            this.actionList.map(action => {
                action.actions = []
            })
            if (row.policies) {
                const checkedKeys = []
                row.policies.map(item => {
                    if (item.action) {
                        this.cachePolicy.push(item)
                        this.actionList.map(action => {
                            if (action.name === item.resource) {
                                this.cachePolicy.splice(this.cachePolicy.indexOf(item), 1)
                                action.actions = item.action.split(',')
                            }
                        })
                        item.action.split(',').map(action => {
                            checkedKeys.push(item.resource + '_' + action)
                        })
                    }
                })
                this.$nextTick(() => {
                    this.$refs.tree.setCheckedKeys(checkedKeys)
                })
            }
        },
        save () {
            const allPolicies = this.actionList.map(item => {
                return {
                    resource: item.name,
                    description: item.description,
                    action: item.actions.join()
                }
            })
            this.form.policies = allPolicies.filter(item => {
                return item.action
            })
            this.form.policies.push(...this.cachePolicy)
            this.loading = true
            const { title, id, name, description, policies, version } = this.form
            const data = { name, description, policies, version }
            if (title === 'Edit Statement') {
                editStatementPolicy(id, data).then(() => {
                    this.fetchData()
                    this.visible = false
                    this.$message.success('Update statement success')
                }).catch(() => {
                    this.loading = false
                })
            } else {
                createStatement(data).then(() => {
                    this.fetchData()
                    this.visible = false
                    this.$message.success('Create statement success')
                }).catch(() => {
                    this.loading = false
                })
            }
        },
        showDelete (id) {
            this.$confirm('This will delete statement. Continue?', 'Warning', {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.loading = true
                deleteStatement(id).then(response => {
                    this.fetchData()
                    this.$message.success('Delete success!')
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.$message.info('Delete canceled')
            })
        },
        fetchMenu () {
            getAllStatementMenus().then(response => {
                this.setTreeId(response)
            })
        },
        setTreeId (datas) {
            for (var i in datas) {
                this.actionList.push({
                    id: datas[i].id,
                    name: datas[i].path,
                    label: datas[i].name,
                    description: '',
                    actions: [],
                    children: datas[i].menuOptions.map(action => {
                        return {
                            id: datas[i].path + '_' + action,
                            name: action,
                            label: action
                        }
                    })
                })
                if (datas[i].children) {
                    this.setTreeId(datas[i].children)
                }
            }
        },
        handleCheckChange (data, checked, indeterminate) {
            this.actionList.map(item => {
                if (item.name === data.id.split('_')[0]) {
                    if (checked) {
                        item.actions.push(data.label)
                    } else {
                        item.actions.splice(item.actions.indexOf(data.label), 1)
                    }
                }
            })
        },
        fetchData () {
            this.loading = true
            getAllStatements().then(response => {
                this.list = response
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        handleSizeChange (val) {
            this.pageable.pageSize = val
        }
    }
}
</script>
<style scoped>
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
</style>
<style>
.resource-tree.zm-tree .zm-tree-node .is-leaf + .zm-checkbox .zm-checkbox__inner{display: inline-block;}
.resource-tree.zm-tree .zm-tree-node .is-leaf + .zm-checkbox{display: inline-block;}
/* .zm-tree .zm-tree-node .zm-checkbox .zm-checkbox__inner{display: none;} */
.zm-tree .zm-tree-node .zm-checkbox{display: none;}
</style>
